/**
 * localStorage mixins
 */

export default {


    methods: {

        sessionSet: function (key, value) {
            localStorage.setItem(key, value);
        },

        sessionGet: function (key) {
            let data = localStorage.getItem("sites");
        }

        // Remove saved data from sessionStorage
        //localStorage.removeItem("key");

        // Remove all saved data from sessionStorage
        //localStorage.clear();

    }
}
